import { getColumnValueFromRowHTML } from "../helpers/rows";
var TableUpdate = /** @class */ (function () {
    function TableUpdate() {
    }
    TableUpdate.prototype.updateSelectedCells = function (column, value) {
        var _this = this;
        if (value === void 0) { value = ''; }
        var ids = AdminColumns.Table.Selection.getIDs();
        if (ids.length === 0) {
            return;
        }
        this.getRows(ids).done(function (response) {
            if (!response.hasOwnProperty('data') || !response.data.hasOwnProperty('table_rows')) {
                return;
            }
            var rows = response.data.table_rows;
            Object.keys(rows).forEach(function (id) {
                var cell = AdminColumns.Table.Cells.get(id, column);
                var iEdit = cell.IEdit;
                if (iEdit) {
                    iEdit.setValueFromRowHTML(rows[id]);
                }
                else {
                    cell.getElement().innerHTML = getColumnValueFromRowHTML(rows[id], column);
                }
            });
            _this.updateSelectedEditingCells(column, rows, value);
        });
    };
    TableUpdate.prototype.updateSelectedEditingCells = function (column, rows, value) {
        var ids = AdminColumns.Table.Selection.getIDs();
        if (ids.length === 0) {
            return;
        }
        var Editing_items = jQuery.ajax({
            url: ajaxurl,
            method: 'post',
            data: {
                action: 'acp_editing_single_request',
                method: 'get_editable_values',
                ids: ids,
                column: column,
                list_screen: AC.list_screen,
                layout: AC.layout,
                _ajax_nonce: AC.ajax_nonce
            }
        });
        Editing_items.done(function (response) {
            response.data.editable_values.forEach(function (setting) {
                if (setting.column_name !== column) {
                    return;
                }
                var cell = AdminColumns.Table.Cells.get(setting.id, column);
                var iEdit = cell.IEdit;
                if (iEdit) {
                    cell.dataStorage.storeRevision(value);
                    iEdit.Editable.setValue(setting.value);
                    iEdit.setValueFromRowHTML(rows[setting.id]);
                }
            });
        });
    };
    TableUpdate.prototype.getRows = function (ids) {
        return jQuery.ajax({
            url: window.location.href,
            method: 'post',
            data: {
                ac_action: 'get_table_rows',
                ac_ids: ids,
                _ajax_nonce: AC.ajax_nonce
            }
        });
    };
    return TableUpdate;
}());
export default TableUpdate;
